// 9fbef606107a605d69c0edbcd8029e5d
import BUNDLEPRODUCT_CONSTANTS from './BundleProduct.constants';

export const setProductDetails = (payload) => {
  return {
    type: BUNDLEPRODUCT_CONSTANTS.SET_BUNDLE_DETAILS,
    payload,
  };
};

export const getProductDetails = (payload) => {
  return {
    type: BUNDLEPRODUCT_CONSTANTS.FETCH_BUNDLE_DETAILS,
    payload,
  };
};

export const getSelectedFitProduct = (payload) => {
  return {
    type: BUNDLEPRODUCT_CONSTANTS.FETCH_SELECTED_FIT_PRODUCT,
    payload,
  };
};

export const setBundleDetails = (payload) => {
  return {
    type: BUNDLEPRODUCT_CONSTANTS.SET_BUNDLE_PRODUCTS_DETAILS,
    payload,
  };
};

export const updateBundleProductDetails = (payload) => {
  return {
    type: BUNDLEPRODUCT_CONSTANTS.UPDATE_BUNDLE_PRODUCT_ITEM,
    payload,
  };
};

export const setDepartmentBundleProducts = (payload) => {
  return {
    type: BUNDLEPRODUCT_CONSTANTS.SET_DEPARTMENT_BUNDLE_PRODUCTS,
    payload,
  };
};

export const clearBundleState = () => {
  return {
    type: BUNDLEPRODUCT_CONSTANTS.CLEAR_BUNDLE_DETAILS,
    payload: {},
  };
};
export const setAddToFavoriteBUNDLE = (payload) => {
  return {
    type: BUNDLEPRODUCT_CONSTANTS.SET_ADD_TO_FAVORITE,
    payload,
  };
};

export const setLoadingState = (payload) => {
  return {
    type: BUNDLEPRODUCT_CONSTANTS.SET_LOADING_STATE,
    payload,
  };
};

export const setPageUrl = (payload) => {
  return {
    type: BUNDLEPRODUCT_CONSTANTS.SET_PAGE_URL,
    payload,
  };
};

export const getInYourBagProductCount = (payload) => ({
  type: BUNDLEPRODUCT_CONSTANTS.GET_IN_YOUR_BAG_PRODUCT_COUNT,
  payload,
});

export const setInYourBagCount = (payload) => ({
  type: BUNDLEPRODUCT_CONSTANTS.SET_IN_YOUR_BAG_COUNT,
  payload,
});

export const setIsBundle = (payload) => ({
  type: BUNDLEPRODUCT_CONSTANTS.SET_IS_BUNDLE,
  payload,
});

export const carryForwardImgUrl = (payload) => {
  return {
    type: BUNDLEPRODUCT_CONSTANTS.CARRY_FORWARD_IMG_URL,
    payload,
  };
};

export const callItemInBag = () => ({ type: BUNDLEPRODUCT_CONSTANTS.CALL_ITEMS_IN_BAG });
